module.exports = __webpack_public_path__ + "media/fonts/Quicksand-Medium-74eb5c183e5f25c68c2e951c434da7d9.ttf";